import React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const AboutPage = () => {

    React.useEffect(() => {

    }, []);

    return (
        <div
            className="d-flex"
        >
            <div>
                <div>
                    <h2>About</h2>
                </div>
                <Button>Click</Button>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About</Link>
                    </li>
                    <li>
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li>
                        <Link to="/nothing-here">Nothing Here</Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default AboutPage;
